import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import tools from '../../utils/tools';
import {
  getOpenId, getWXAppId, getMarketingWxConfiguration, getMarketingOpenId,
} from '../../service/chat-service';

const propTypes = {
  needJudgePages: PropTypes.arrayOf(PropTypes.string).isRequired,
  // 需要微信授权页面 例如：["/pay","/productDetail"]
  children: PropTypes.element.isRequired,
};

const defaultProps = {
};

export default class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showStatus: false,
    };
  }

  componentDidMount() {
    this.judgeIsWeiXinClient();
  }

  judgeIsWeiXinClient = async () => {
    const { needJudgePages } = this.props;
    const locationPathName = window.location.pathname;
    const needJudge = needJudgePages.some((value) => locationPathName.indexOf(value) !== -1);
    const isWeixinClient = tools.isWeixinCient();

    if (!isWeixinClient || !needJudge) return this.setState({ showStatus: true });

    const productId = tools.getQueryString('productId');
    const WXCode = tools.getQueryString('code');

    if (!WXCode && !!productId) {
      localStorage.clear();

      // 动态获取 微信 appId
      try {
        const { code, data, message } = await getWXAppId(productId);
        if (code === 10000) window.location.href = tools.toWxth(data.appid);
        else Toast.show(message || '获取微信 appId 失败');
      } catch (e) {
        Toast.show(e || '获取微信 appId 失败');
      }
    } else if (!WXCode && !productId) {
      // 营销授权
      const yxAppIdRes = await getMarketingWxConfiguration();
      if (yxAppIdRes.code === 10000) {
        window.location.href = tools.toSnsapiBaseWxth(yxAppIdRes.data.appId);
      }
    } else {
      const openId = localStorage.getItem('openId');
      const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');
      try {
        const res = !openId && !!productId && await getOpenId(`?code=${WXCode}&productId=${productId}`);
        if (res.code === 10000) {
          localStorage.setItem('openId', res.data);

          // 营销授权
          const yxAppIdRes = await getMarketingWxConfiguration();
          if (yxAppIdRes.code === 10000) {
            window.location.href = tools.toSnsapiBaseWxth(yxAppIdRes.data.appId);
          }
        } else if (!snsapiBaseOpenId) {
          // 营销获取openid
          const yxOpenIdRes = await getMarketingOpenId(WXCode);
          if (yxOpenIdRes.code === 10000) {
            localStorage.setItem('snsapiBaseOpenId', yxOpenIdRes.data);
          }
          this.setState({ showStatus: true });
        } else {
          this.setState({ showStatus: true });
        }
      } catch (e) {
        Toast.show(e);
      }
    }
    return true;
  };

  render() {
    const { showStatus } = this.state;
    const { children } = this.props;
    return (
      <>
        {showStatus ? children : null}
      </>
    );
  }
}

Auth.propTypes = propTypes;
Auth.defaultProps = defaultProps;
